// routes/AccountRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Accounts from '../components/Accounts/Accounts';

export const accountRoutes = (
  <Route path="/accounts" element={<MainLayout />}>
    <Route index element={<Accounts />} />
  </Route>
);
